<script>
    import store from '../Stores/auth-store';
    import {goto} from '@sveltech/routify';

    store.logout();
    $goto('/login');
</script>